import { useState } from "react";
export const useOrganizationNameEditor = ({ updateOrganizationName })=>{
    const [isEditingName, setIsEditingName] = useState(false);
    const [editedName, setEditedName] = useState("");
    const [nameSaveError, setNameSaveError] = useState(null);
    const startEditing = (initialValue)=>{
        setEditedName(initialValue);
        setNameSaveError(null);
        setIsEditingName(true);
    };
    const cancelEditing = ()=>{
        setIsEditingName(false);
        setEditedName("");
        setNameSaveError(null);
    };
    const saveEditedName = async ()=>{
        const trimmedName = editedName.trim();
        if (!trimmedName) {
            return;
        }
        try {
            setNameSaveError(null);
            await updateOrganizationName(trimmedName);
            setIsEditingName(false);
            setEditedName("");
        } catch (error) {
            const fallbackMessage = "Failed to update organization name";
            setNameSaveError(error instanceof Error ? error.message : fallbackMessage);
        }
    };
    return {
        isEditingName,
        editedName,
        nameSaveError,
        setEditedName,
        startEditing,
        cancelEditing,
        saveEditedName
    };
};
export default useOrganizationNameEditor;
